import { getToken } from '@/utils';
import axios from 'axios';
var globalBaseURL = '';
var tokenKey = '';
var recruiterTokenKey = '';
var organizationId;
export var setBaseURL = function (baseURL) {
    globalBaseURL = baseURL;
};
export var setOrganizationId = function (orgId) {
    organizationId = orgId;
};
export var setTokenKey = function (key) {
    tokenKey = key;
};
export var setRecruiterTokenKey = function (key) {
    recruiterTokenKey = key !== null && key !== void 0 ? key : '';
};
var axiosInstance = axios.create({
    baseURL: globalBaseURL,
});
axiosInstance.interceptors.request.use(function (config) {
    var _a;
    // Update the baseURL if it has changed
    if (config.baseURL !== globalBaseURL) {
        config.baseURL = globalBaseURL;
    }
    // Add token logic
    var tokenKeyToUse = ((_a = config.url) === null || _a === void 0 ? void 0 : _a.includes('get-organization-profile/'))
        ? recruiterTokenKey
        : tokenKey;
    var token = tokenKeyToUse ? getToken(tokenKeyToUse) : null;
    if (token) {
        config.headers.Authorization = "Bearer ".concat(token);
    }
    // Add organizationId logic
    // if (organizationId) {
    //   config.headers['Organization-Id'] = organizationId;
    // }
    return config;
});
axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a;
    if (axios.isAxiosError(error)) {
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
            var keyStructure_1 = tokenKey.split('.');
            if (keyStructure_1.length === 2 &&
                (keyStructure_1[0].toLocaleLowerCase() === 'localstorage' ||
                    keyStructure_1[0].toLocaleLowerCase() === 'cookie')) {
                // Clear the token from local storage or cookie if it exists
                if (keyStructure_1[0].toLocaleLowerCase() === 'localstorage') {
                    if (localStorage.getItem(keyStructure_1[1])) {
                        localStorage.removeItem(keyStructure_1[1]);
                    }
                }
                else if (keyStructure_1[0].toLocaleLowerCase() === 'cookie') {
                    if (document.cookie
                        .split(';')
                        .some(function (item) { return item.trim().startsWith("".concat(keyStructure_1[1], "=")); })) {
                        document.cookie = "".concat(keyStructure_1[1], "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
                    }
                }
            }
        }
    }
    return Promise.reject(error);
});
export default axiosInstance;
